import superMeta from '../_PARAM/metaParamNode.mjs'

export default {
    ...superMeta,
    name: '请求参数',
    type: 'REQ',
}
